import GeneralHeader from "components/Headers/GeneralHeader";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";
import React, { useState } from "react";
import SellPerDateAndUsers from "./SellPerDateAndUsers";
import SellPerDateAndCustomer from "./SellPerDateAndCustomer";
import SellPerDateAndItem from "./SellPerDateAndItem";
import SellPerDateAndZone from "./SellPerDateAndZone";
import ExpensesPerDateAndUsers from "./ExpensesPerDateAndUsers";
import PurchaseandStockRemains from "./PurchaseandStockRemains";
import SellUserShare from "./SellUserShare";
import SellDebtReport from "./SellDebt";
import MonthlyReport from "./MonthlyReport";
import SellUserCompareByDate from "./SellUserCompareByDate";
import SellZoneCompareByDate from "./SellZoneCompareByDate";
import SellCityCompareByDate from "./SellCityCompareByDate";
import SellNeighbourCompareByDate from "./SellNeighbourCompareByDate";
import SellCustomerCompareByDate from "./SellCustomerCompareByDate";
import EmployeesAccounting from "./EmployeesAccounting";
import DoctorVisitations from "./DoctorVisitations";
import SellPaidByMandwb from "./SellPaidByMandwb";
import MonthlyProfitOrLoss from "./MonthlyProfitOrLoss";
import PayParnerProfit from "./PayParnerProfit";
import SellPaidByAccountant from "./SellPaidByAccountant";
import ExpensesCompareByType from "./ExpensesCompareByType";
import ExpensesCompareByCities from "./ExpensesCompareByCities";
import ExpensesCompareByZones from "./ExpensesCompareByZones";
import ExpensesCompareByUsers from "./ExpensesCompareByUsers";
import ItemSummary from "./ItemSummary";
import SoldItemsByZones from "./SoldItemsByZones";
import SoldItemsByUsers from "./SoldItemsByUsers";
import CustomersDiscountList from "./CustomersDiscountList";
import DoctorLastVisitation from "./DoctorLastVisitation";
import SoldItemsToCustomer from "./SoldItemsToCustomer";
import UnPaidInvoiceByCityOrZone from "./UnPaidInvoiceByCityOrZone";
import SellGroupByUserNameAndZone from "./SellGroupByUserNameAndZone";
import CustomersPaid from "./CustomersPaid";
import ItemAverage from "./ItemAverage";

const ReportList = require("./reportList.json");

export default function Index() {
  const [reportType, setReportType] = useState();
  const [reportCategory, setReportCategory] = useState();
  function renderPage() {
    if (reportType === "sellByDateAndUser") return <SellPerDateAndUsers />;
    else if (reportType === "sellByDateAndCustomer")
      return <SellPerDateAndCustomer />;
    else if (reportType === "sellByDateAndItem") return <SellPerDateAndItem />;
    else if (reportType === "sellByDateAndZone") return <SellPerDateAndZone />;
    else if (reportType === "expensesByDateAndUser")
      return <ExpensesPerDateAndUsers />;
    else if (reportType === "expensesCompareByType")
      return <ExpensesCompareByType />;
    else if (reportType === "expensesCompareByCities")
      return <ExpensesCompareByCities />;
    else if (reportType === "expensesCompareByZones")
      return <ExpensesCompareByZones />;
    else if (reportType === "expensesCompareByUsers")
      return <ExpensesCompareByUsers />;
    else if (reportType === "PurchaseandStockRemains")
      return <PurchaseandStockRemains />;
    else if (reportType === "SellUserShare") return <SellUserShare />;
    else if (reportType === "SellDebt") return <SellDebtReport />;
    else if (reportType === "MonthlyReport") return <MonthlyReport />;
    else if (reportType === "UserCompareByDate")
      return <SellUserCompareByDate />;
    else if (reportType === "CustomerCompareByDate")
      return <SellCustomerCompareByDate />;
    else if (reportType === "CityCompareByDate")
      return <SellCityCompareByDate />;
    else if (reportType === "ZoneCompareByDate")
      return <SellZoneCompareByDate />;
    else if (reportType === "NeighbourCompareByDate")
      return <SellNeighbourCompareByDate />;
    else if (reportType === "EmployeesAccounting")
      return <EmployeesAccounting />;
    else if (reportType === "DoctorVisitations") return <DoctorVisitations />;
    else if (reportType === "SellPaidByMandwb") return <SellPaidByMandwb />;
    else if (reportType === "SellPaidByAccountant")
      return <SellPaidByAccountant />;
    else if (reportType === "MonthlyProfitOrLoss")
      return <MonthlyProfitOrLoss />;
    else if (reportType === "PayParnerProfit") return <PayParnerProfit />;
    else if (reportType === "ItemSummary") return <ItemSummary />;
    else if (reportType === "SoldItemsByZones") return <SoldItemsByZones />;
    else if (reportType === "SoldItemsByUsers") return <SoldItemsByUsers />;
    else if (reportType === "CustomersDiscountList")
      return <CustomersDiscountList />;
    else if (reportType === "DoctorLastVisitation")
      return <DoctorLastVisitation />;
    else if (reportType === "SoldItemsToCustomer")
      return <SoldItemsToCustomer />;
    else if (reportType === "UnPaidInvoiceByCityOrZone")
      return <UnPaidInvoiceByCityOrZone />;
    else if (reportType === "SellGroupByUserNameAndZone")
      return <SellGroupByUserNameAndZone />;
    else if (reportType === "CustomersPaid") return <CustomersPaid />;
    else if (reportType === "ItemAverage") return <ItemAverage />;
  }

  function ReportCategoryRender() {
    let items = [];
    ReportList.map((item) =>
      items.push(
        <option key={item.category} value={item.category}>
          {item.category}
        </option>
      )
    );
    return items;
  }
  function ReportListRender() {
    if (!reportCategory) return null;
    const category = ReportList.find((cat) => cat.category === reportCategory);

    if (!category) return null;

    return category.options.map((item) => (
      <option key={item.value} value={item.value}>
        {item.label}
      </option>
    ));
  }
  return (
    <>
      <GeneralHeader />
      <Container className="mt--7" fluid style={{ color: "black" }}>
        <Row className="mt-5">
          <Col className="mb-5 mb-xl-0" xl="12">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="align-items-center">
                  <Col xs="4">
                    <span style={{ fontSize: 16 }}>Reports</span>
                  </Col>
                  <Col>
                    <Input
                      className="form-control-alternative"
                      value={reportCategory}
                      id="reportCategory"
                      placeholder="reportCategory"
                      type="select"
                      onChange={(e) => setReportCategory(e.target.value)}
                      style={{ fontSize: 16, color: "black", height: 45 }}
                    >
                      <option value="">---Report Category---</option>
                      {ReportCategoryRender()}
                    </Input>
                  </Col>
                  <Col>
                    <Input
                      className="form-control-alternative"
                      value={reportType}
                      id="reportType"
                      placeholder="reportType"
                      type="select"
                      onChange={(e) => setReportType(e.target.value)}
                      style={{ fontSize: 16, color: "black", height: 45 }}
                    >
                      <option value="">---Report Type---</option>
                      {ReportListRender()}
                    </Input>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>{renderPage()}</CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
